import { apiRequest } from './client';
import type {
  AnalyticsResponse,
  CalendarResponse,
  HomeResponse,
  MonthlyReportResponse,
} from './types';

export function getHome(userId: string): Promise<HomeResponse> {
  return apiRequest<HomeResponse>(`/analytics/home?user_id=${encodeURIComponent(userId)}`);
}

export function getEmotionAnalytics(params: {
  userId: string;
  period: '7d' | '30d' | 'month' | 'year' | 'custom';
  startDate?: string | null;
  endDate?: string | null;
}): Promise<AnalyticsResponse> {
  const query = new URLSearchParams({
    user_id: params.userId,
    period: params.period,
  });
  if (params.period === 'custom') {
    if (params.startDate) query.set('start_date', params.startDate);
    if (params.endDate) query.set('end_date', params.endDate);
  }
  return apiRequest<AnalyticsResponse>(`/analytics/emotions?${query.toString()}`);
}

export function getCalendarAnalytics(params: {
  userId: string;
  year: number;
  month: number;
}): Promise<CalendarResponse> {
  const query = new URLSearchParams({
    user_id: params.userId,
    year: String(params.year),
    month: String(params.month),
  });
  return apiRequest<CalendarResponse>(`/analytics/calendar?${query.toString()}`);
}

export function getMonthlyReport(params: {
  userId: string;
  year: number;
  month: number;
}): Promise<MonthlyReportResponse> {
  const query = new URLSearchParams({
    user_id: params.userId,
    year: String(params.year),
    month: String(params.month),
  });
  return apiRequest<MonthlyReportResponse>(`/analytics/calendar/monthly-report?${query.toString()}`);
}
